import { render, staticRenderFns } from "./YCheckbox.vue?vue&type=template&id=208f0094&scoped=true"
import script from "./YCheckbox.vue?vue&type=script&lang=js"
export * from "./YCheckbox.vue?vue&type=script&lang=js"
import style0 from "./YCheckbox.vue?vue&type=style&index=0&id=208f0094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208f0094",
  null
  
)

export default component.exports